
const companyData = [
  { label: '医院名', value: 'おかやま鍼灸院' },
  { label: '代表者', value: '岡山 太郎' },
  { label: '所在地', value: '〒700-0000 岡山市北区○○町1-2-3' },
  { label: '電話番号', value: '086-012-3456' },
  { label: 'FAX', value: '086-012-3457' },
  { label: '設立', value: '2000年' },
  { label: '従業員数', value: '5名' },
  { label: '営業時間', value: '9:00〜18:00' },
  { label: '定休日', value: '日曜日・祝日' },
  { label: '資格', value: '国家資格（はり師・きゅう師）保持者在籍' },
  { label: '加入団体', value: '公益社団法人 全日本鍼灸マッサージ師会' },
];

const CompanyInfo = () => {
  return (
    <section className="py-12 sm:py-16 md:py-24 px-4 sm:px-6 bg-gradient-to-b from-white to-sub/20">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10 sm:mb-12 md:mb-16">
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl text-primary mb-3 sm:mb-4 px-4">
            <strong>会社概要</strong>
          </h2>
          <p className="text-gray-600 text-sm sm:text-base px-4">
            <strong>岡山市北区</strong>で地域の皆様の健康をサポートしています
          </p>
        </div>

        <article className="bg-white rounded-2xl sm:rounded-3xl shadow-xl overflow-hidden">
          <div className="divide-y divide-gray-100">
            {companyData.map((item, index) => (
              <div
                key={index}
                className="grid grid-cols-1 md:grid-cols-3 gap-2 sm:gap-4 p-4 sm:p-6 hover:bg-sub/10 transition-colors"
              >
                <dt className="font-semibold text-gray-600 text-xs sm:text-sm">{item.label}</dt>
                <dd className="md:col-span-2 text-gray-900 text-xs sm:text-sm">{item.value}</dd>
              </div>
            ))}
          </div>
        </article>

        <div className="mt-10 sm:mt-12 md:mt-16 bg-accent/20 rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-10">
          <h3 className="font-serif text-2xl sm:text-3xl text-primary mb-4 sm:mb-6 text-center">アクセス</h3>
          <div className="aspect-video rounded-xl sm:rounded-2xl overflow-hidden mb-4 sm:mb-6">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3281.8!2d133.935!3d34.6617!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzTCsDM5JzQyLjEiTiAxMzPCsDU2JzA2LjAiRQ!5e0!3m2!1sja!2sjp!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="おかやま鍼灸院の地図"
            ></iframe>
          </div>
          <div className="text-center">
            <p className="text-gray-700 text-xs sm:text-sm mb-2">
              <i className="ri-map-pin-line text-primary mr-2"></i>
              岡山市北区○○町1-2-3
            </p>
            <p className="text-gray-600 text-xs sm:text-sm">
              JR岡山駅より徒歩10分 / 専用駐車場3台完備
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyInfo;
